// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

// COB-500: the entry control for "Flush browser stored key material", at the
// foot of the Wallet page.
//
// It lives there — not in the header, where it first shipped — because it is
// a destructive, account-scoped action: it belongs beside the other
// key-lifecycle control (the backup-phrase card) rather than in global chrome
// one click from "Lock session", where the two invite exactly the confusion
// the flow's first sentence has to spend itself undoing.
//
// COB-506: the page only renders this card for a `software` session — see
// `wipeCardVisible` in `pages/wallet.tsx` for why. The flow it opens still
// handles every backend; this card is simply not offered to the other two.
//
// Its own module, deliberately: `browser-wipe-modal.tsx` imports
// `revealFailureMessage` from `pages/wallet.tsx`, so exporting the card from
// there would close an import cycle between the page and the component. This
// module imports nothing but the trigger, which imports nothing at all.

import { openBrowserWipe } from '../browser-wipe-trigger.js';
import '../styles/browser-wipe.css';

export function WipeBrowserCard() {
  return (
    <div class="wallet-section wallet-section--danger" data-testid="wipe-browser-card">
      <div class="wallet-section-title">Flush browser stored key material</div>
      <p class="wallet-section-desc">
        Remove this account's encrypted keys and local data from this browser
        — an extra level of protection for a browser and machine you rarely
        use or are switching from. Your account, your vaults and your Bitcoin
        are untouched, and you can sign back in here later by restoring your
        backed-up seed phrase.
      </p>
      <button
        type="button"
        class="btn btn-danger"
        onClick={() => {
          openBrowserWipe();
        }}
      >
        Flush browser stored key material
      </button>
    </div>
  );
}
